import {BrowserRouter} from 'react-router-dom';
import {QueryClientProvider} from '@tanstack/react-query';
import {queryClient} from './foundation/queryClient';
import {Layout} from './foundation/Layout/Layout';
import {Router} from './foundation/Layout/Router';
import {UserSession} from './api/models';
import {useEffect, useState} from 'react';
import {AuthContext, CartContext} from './api/context';
import {getUserSession as fetchSessionDetails} from './api';
import {isUserPermittedForRole} from './api/utils';
import {useCart} from './api/cart';
import Percept from '@perceptinsight/percept-js';
import { PERCEPT_API_KEY } from './api/config';

export const App = () => {
    const [userDetails, setUserDetails] = useState<UserSession | undefined>(undefined);
    const {
        cart,
        updateCart,
        getCart,
        getCartItem,
        getWebsiteId,
        setWebsiteId,
        getCartAmount,
        setCatalogItems,
        getCatalogItems,
        clearCart,
    } = useCart();

    useEffect(() => {
        Percept.init(PERCEPT_API_KEY); 
    }, []);

    return (
        <QueryClientProvider client={queryClient}>
            <AuthContext.Provider value={{userDetails, setUserDetails, fetchSessionDetails, isUserPermittedForRole}}>
                <CartContext.Provider
                    value={{
                        getWebsiteId,
                        setWebsiteId,
                        cart,
                        clearCart,
                        setCatalogItems,
                        getCatalogItems,
                        updateCart,
                        getCartItem,
                        getCart,
                        getCartTotal: getCartAmount,
                    }}>
                    <BrowserRouter basename='/'>
                        <Layout>
                            <Router />
                        </Layout>
                    </BrowserRouter>
                </CartContext.Provider>
            </AuthContext.Provider>
        </QueryClientProvider>
    );
};
